// src/features/whatsapp/pages/ReferralMessagePage.tsx
// Re-cableado a lealify-base (Inc11): aviso al REFERIDOR cuando su referido se registra (evento referral).
import React from 'react';
import { Gift } from 'lucide-react';
import EventMessageEditor from '../components/EventMessageEditor';

const ReferralMessagePage: React.FC = () => (
  <EventMessageEditor
    eventKey="referral"
    title="Mensaje de Referido"
    subtitle="Avisa por WhatsApp a quien recomienda cuando su invitado se registra y se le acreditan puntos"
    icon={<Gift className="h-5 w-5 sm:h-6 sm:w-6 mr-2 text-emerald-500" />}
    feature="Mensaje de Referido"
    defaultTemplate="🎉 ¡@nombre, @referido se registró con tu invitación en @negocio! Ganaste @puntos puntos. ¡Gracias por recomendarnos!"
    variables={[
      { key: '@nombre', label: 'Nombre del referidor', example: 'María' },
      { key: '@referido', label: 'Nombre del nuevo cliente', example: 'Juan' },
      { key: '@negocio', label: 'Nombre de tu negocio', example: 'tu negocio', aliases: ['@marca'] },
      { key: '@puntos', label: 'Puntos ganados por referir', example: '50' },
    ]}
    allowImage
    enabledHint={{ on: 'El referidor recibe un aviso al acreditarse sus puntos', off: 'Activar para avisar a quien recomienda' }}
    stepGuide={{
      description: 'Cuando un cliente nuevo se registra con el código de un referidor y se acreditan los puntos, el sistema avisa al referidor por WhatsApp automáticamente.',
      steps: ['Referido se registra', 'Se acreditan puntos', 'WhatsApp al referidor'],
    }}
    requirementsReady="Todo listo — tus clientes que recomiendan recibirán su aviso automáticamente"
  />
);

export default ReferralMessagePage;
